export const API_URL = "https://plesh-remote-multi-user-api-y2qbyk5t3a-ew.a.run.app/"
//export const API_URL = "http://localhost:8080/"
//export const TOOLPRESS_API = "https://api-tool-press-yn26wrnl4q-ey.a.run.app"
export const TOOLPRESS_API = "https://toolpress-api.2ndstage.app"

export const THEME_CONFIG = {
    mode:"dark",
    gradients: {
        default: ['#FFFFFF', '#FFFFFF'],
        home_question: ['#009AA6', '#009AA6'],
    },
    borders : {
        default: 'none',
        home_question: 'none'
    },
    borderRadius: {
        default: '0rem',
        photo: '0rem',
        textField: '0rem !important',
    },
    shadows : {
        default: 'none',
        home_question: 'none'
    },

    agendaStyle : {
        headerColor: '#EA4D95',
        boxShadow: '0px 8px 10px 0px rgba(0,0,0,0.2)',
        borderRadius: '0px',
        headerTextColor: '#fff',
        contentTextColor: '#fff',
        iconColor: '#fff',
        backgroundColor: '#2e1344',
    },

    agendaViewStyle : {
        todayHeaderBkgColor: '#EA4D95',
        headerBkgColor: '#1c0b28',
        todayTitleColor: '#fff',
        titleColor: '#fff',
        timesColor: '#fff',
        textColor: '#fff',
        accordionBkgColor: '#2e1344'
    },

    primary: '#fff',
    secondary: '#263238',
    accent: '#fff',
    text: '#eceff1',
    buttonText: {
        home_question: '#fff',
        default: '#009AA6'
    },
    background:"#009AA6",

    homeQuestionIcon: false,

    poll:{
        default:"#FFFFFF",
        answered:"#7BC8CE",
        correct: '#72CE9B',
        wrong: '#CE7B7B'
    },
    pollBorder: {
        default:"#FFFFFF",
        answered:"#7BC8CE",
        correct: '#72CE9B',
        wrong: '#CE7B7B'
    },
    pollTextColor: {
        default:"#009AA6",
        answered:"#fff",
        correct: '#fff',
        wrong: '#E3A6A6'
    }
}